import type { ChildCustomerTypes, SelectOption } from '../types';
import { RBACAccessType } from '../types';

export const MAX_DESCRIPTION_LEN = 500;
export const MAX_INPUT_LEN = 32;
export const MAX_SLUG_LEN = 32;

export const SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const modalErrorMap = {
  400: 'Invalid params or missing required params.', // unlikely
  409: 'Customer already exists!',
  500: 'Error creating customer.',
};

/**
 * Labels that map to each type of RBACAccess
 */
export const accessTypeLabelMap = {
  [RBACAccessType.None]: 'Request Access',
  [RBACAccessType.Temporary]: 'Temporary',
  [RBACAccessType.Pending]: 'Pending',
  [RBACAccessType.Permanent]: 'Permanent',
};

/**
 * Select dropdown options for the two types of AFEF child account
 */
export const childTypeOptions: SelectOption<ChildCustomerTypes>[] = [
  { name: 'Autonomous Child', value: 'autonomous' },
  { name: 'Controlled Child', value: 'controlled' },
];

